"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ConstructionProgressStub = require("./ConstructionProgressStub");
Object.keys(_ConstructionProgressStub).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ConstructionProgressStub[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ConstructionProgressStub[key];
    }
  });
});